import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class V3GroundPositionsDataSourceService {
  baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop`;
  constructor(
    private http: HttpClient
  ) { }

  searchLevels(search: string) {
    return this.http.get<string[]>(`${this.baseUrl}/ground-positions?search=${search}&searchColumns=levelName`).pipe(
      map((response: any) => {
        const mapped: string[] = response.values.map(item => item.levelName).sort((a, b) => a.localeCompare(b));
        return [... new Set(mapped)];
      })
    );
  }

  searchGroundPositionGroup(search: string) {
    return this.http.get<string[]>(`${this.baseUrl}/ground-position-groups?search=${search}`).pipe(
      map((response: any) => {
        const mapped: string[] = response.map(item => item.name).sort((a, b) => a.localeCompare(b));
        return [... new Set(mapped)];
      })
    );
  }

  searchGroundPositionAlias(search: string) {
    return this.http.get<string[]>(`${this.baseUrl}/ground-positions?search=${search}&searchColumns=alias`).pipe(
      map((response: any) => {
        const mapped: string[] = response.values.map(item => item.alias).sort((a, b) => a.localeCompare(b));
        return [... new Set(mapped)];
      })
    );
  }
}
